import React from 'react';
import { ContentMasteryErrorRateListService } from '../../services/ContentListService';
import ContentMasteryTestErrorRateSummary from './ContentMasteryTestErrorRateSummary';
import { observer } from 'mobx-react';

const ContentMasteryTestErrorRateSummaryContainer = () => {
  const summary = ContentMasteryErrorRateListService.getChart();
  return (
    <ContentMasteryTestErrorRateSummary
      isLoading={
        ContentMasteryErrorRateListService.fetchCurrent.fetching ||
        ContentMasteryErrorRateListService.fetchPrevious.fetching
      }
      previousValue={summary.previous}
      currentValue={summary.current}
      formatter={ContentMasteryErrorRateListService.getFormattedValue}
    />
  );
};

export default observer(ContentMasteryTestErrorRateSummaryContainer);
